// Slow editorial marquee - one row, uppercase, gold + white, hairline dividers.
// Used sparingly as a manifesto band between sections.

const DEFAULT_ITEMS = [
  "Look established",
  "Where clients find you",
  "Personal brand",
  "Websites that convert",
  "Local search",
  "Listings that recognise your name",
  "Referral-ready presence",
  "Reviews & reputation",
];

export default function Marquee({ items = DEFAULT_ITEMS, testId = "marquee" }) {
  const track = [...items, ...items, ...items];
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden border-y border-[#27272a] bg-[#0a0a0a] py-8"
    >
      <div
        className="flex whitespace-nowrap will-change-transform"
        style={{
          animation: "am-marquee 42s linear infinite",
        }}
      >
        {track.map((it, i) => (
          <span
            key={i}
            className="flex items-center gap-6 md:gap-10 px-6 md:px-10 font-heading text-3xl md:text-5xl lg:text-6xl tracking-tight"
          >
            <span
              className={
                i % 2 === 0 ? "text-white" : "text-[#C8A24B] italic font-light"
              }
              style={{
                fontFamily: i % 2 === 0 ? undefined : "Playfair Display, serif",
              }}
            >
              {it}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#C8A24B] opacity-70" />
          </span>
        ))}
      </div>
      <style>{`
        @keyframes am-marquee {
          from { transform: translate3d(0,0,0); }
          to { transform: translate3d(-33.3333%,0,0); }
        }
      `}</style>
    </div>
  );
}
